export default "../css/c6776e8228bee1ff1106209c1d7160aa.ttf";